import dayjs from 'dayjs';

import {
  SalaryScaleFormValues,
  SalaryScalePostRequest,
  SalaryScalePutRequest
} from '../../../types';

import { convertFlagsObjectToArray } from 'utils/misc';

export const convertPayloadForSave = (
  data: SalaryScaleFormValues
): SalaryScalePutRequest | SalaryScalePostRequest => ({
  ...data,
  valid: {
    from: data.valid.from
      ? dayjs(data.valid.from).startOf('day').toISOString()
      : null,
    to: data.valid.to ? dayjs(data.valid.to).startOf('day').toISOString() : null
  },
  flags: convertFlagsObjectToArray(data.flags)
});
